/**
 * Created by Jerker Nord on 2021-01-27.
 */

import { AssetQualityLevel, IResourcesGroupConfig } from "@nolimitcity/slot-game/bin/asset/Asset";
import { BitmapFontAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import { TextureAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import { SpineAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class TombstoneRipGameAssets {

    static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static BITMAP_FONT_MULTIPLIER = "Multiplier";
    static BITMAP_FONT_FS_INTRO_NUMBER_FS = "fsIntroNumber_FREESPIN";
    static BITMAP_FONT_FS_INTRO_NUMBER_FS_SUPER = "fsIntroNumber_FREESPIN_SUPER";
    static BITMAP_FONT_SUPERFS_GLOW_MUL = "SuperFSGlowMul";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset(TombstoneRipGameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(TombstoneRipGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(TombstoneRipGameAssets.BITMAP_FONT_MULTIPLIER, "fonts/bitmapfonts/Multiplier.fnt"),
                    new BitmapFontAsset(TombstoneRipGameAssets.BITMAP_FONT_FS_INTRO_NUMBER_FS, "fonts/bitmapfonts/fsIntroNumber_FREESPIN.fnt"),
                    new BitmapFontAsset(TombstoneRipGameAssets.BITMAP_FONT_FS_INTRO_NUMBER_FS_SUPER, "fonts/bitmapfonts/fsIntroNumber_FREESPIN_SUPER.fnt"),
                    new BitmapFontAsset(TombstoneRipGameAssets.BITMAP_FONT_SUPERFS_GLOW_MUL, "fonts/bitmapfonts/Super_FS_glow_font.fnt")
                ]
            },
            {
                name: "backgrounds",
                assets: [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                    new TextureAsset("backgroundsJpeg2", "sheets/backgroundsJpeg/backgroundsJpeg2.json"),
                    new TextureAsset("backgroundsJpeg3", "sheets/backgroundsJpeg/backgroundsJpeg3.json"),
                    new TextureAsset("backgroundsJpeg4", "sheets/backgroundsJpeg/backgroundsJpeg4.json"),
                    new TextureAsset("backgroundsJpeg5", "sheets/backgroundsJpeg/backgroundsJpeg5.json")
                ]
            },
            {
                name: "mainSpecial",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("main8", "sheets/main/main8.json"),
                ]
            },
            {
                name: "main",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json"),
                    new TextureAsset("main7", "sheets/main/main7.json"),
                    new TextureAsset("main9", "sheets/main/main9.json"),
                    new TextureAsset("main10", "sheets/main/main10.json"),
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainNoCompress0", "sheets/mainnocompress/main0.json"),
                    new TextureAsset("mainNoCompress1", "sheets/mainnocompress/main1.json"),
                    new TextureAsset("mainNoCompress2", "sheets/mainnocompress/main2.json")
                ]
            },
            {
                name: "mainHigh",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("mainHigh0", "sheets/main/mainHigh0.json")
                ]
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbolsJpeg0", "sheets/symbols/symbolsJpeg0.json")
                ],
                animations: {}
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("W1", "spine/W1.json"),
                    new SpineAsset("W2", "spine/W2.json"),
                    new SpineAsset("W3", "spine/W3.json"),
                    new SpineAsset("WRope", "spine/wildRoop.json"),
                    new SpineAsset("WXSAnimation", "spine/WXS.json"),
                    new SpineAsset("WRSAnimation", "spine/WRS.json"),
                    new SpineAsset("WRSSplit", "spine/WRS_split.json"),
                    new SpineAsset("WXSSplit", "spine/WXS_split.json"),
                    new SpineAsset("WXS_Wild", "spine/WXS_wildX2.json"),
                    new SpineAsset("S1", "spine/S1.json"),
                    new SpineAsset("S1Effects", "spine/S1Effects.json"),
                    new SpineAsset("S2", "spine/S2.json"),
                    new SpineAsset("SEffects", "spine/SEffects.json"),
                    new SpineAsset("W0Landing", "spine/W0Landing.json"),
                    new SpineAsset("initialGlow", "spine/initGlow.json"),
                    new SpineAsset("superFSFire", "spine/SFfire.json"),
                    new SpineAsset("superFSDust", "spine/SFdust.json"),
                    new SpineAsset("nearWin", "spine/nearWin_normal.json"),
                    new SpineAsset("nearWinBlend", "spine/nearWin_blend.json"),
                    new SpineAsset("nearWinSmoke", "spine/nearWin_smoke.json"),
                    new SpineAsset("reel5Burning", "spine/reel05Burning.json"),
                    new SpineAsset("reel5Frame", "spine/reel05frame.json"),
                    new SpineAsset("reel5Glow", "spine/reel05Glow.json"),
                    new SpineAsset("superMatchBg", "spine/sfMatchBgBlend.json"),
                    new SpineAsset("superMWild", "spine/sfMWild.json"),
                    new SpineAsset("superMWildBlend", "spine/sfMWildBlend.json"),
                    new SpineAsset("superMFire", "spine/sfMFire.json"),
                    new SpineAsset("reel2ButtonNormal", "spine/reel2buttonNormal.json"),
                    new SpineAsset("reel2ButtonBlend", "spine/reel2buttonBlend.json"),
                    new SpineAsset("fsIntroBg", "spine/fsintro/fsIntroBg.json"),
                    new SpineAsset("fsIntroPoster", "spine/fsintro/fsIntroPoster.json"),
                    new SpineAsset("fsIntroDust", "spine/fsintro/fsIntroDust.json"),
                    new SpineAsset("sfsIntroBg", "spine/fsintro/sfsIntroBg.json"),
                    new SpineAsset("sfsIntro", "spine/fsintro/sfsIntro.json"),
                    new SpineAsset("sfsIntroDust", "spine/fsintro/sfsIntroDust.json"),
                    new SpineAsset("sfsGirlHead", "spine/fsintro/girlHead.json"),
                    new SpineAsset("bigWinTextBlend", "spine/bigwin/bigWinTextBlend.json"),
                    new SpineAsset("bigWinTextNormal", "spine/bigwin/bigWinTextNormal.json"),
                    new SpineAsset("bigWinPhoto1", "spine/bigwin/bigWinPhoto1.json"),
                    new SpineAsset("bigWinPhoto2", "spine/bigwin/bigWinPhoto2.json"),
                    new SpineAsset("bigWinPhoto3", "spine/bigwin/bigWinPhoto3.json"),
                    new SpineAsset("bigWinPhoto4", "spine/bigwin/bigWinPhoto4.json"),
                    new SpineAsset("bigWinPhoto5", "spine/bigwin/bigWinPhoto5.json"),
                    new SpineAsset("bigWinDust", "spine/bigwin/bigWinDust.json"),
                    new SpineAsset("bigWinL1Normal", "spine/bigwin/bigWinL1Normal.json"),
                    new SpineAsset("bigWinL2Normal", "spine/bigwin/bigWinL2Normal.json"),
                    new SpineAsset("bigWinL3Normal", "spine/bigwin/bigWinL3Normal.json"),
                    new SpineAsset("bigWinL4Normal", "spine/bigwin/bigWinL4Normal.json"),
                    new SpineAsset("bigWinL5Normal", "spine/bigwin/bigWinL5Normal.json"),
                    new SpineAsset("bigWinL1Blend", "spine/bigwin/bigWinL1Blend.json"),
                    new SpineAsset("bigWinL2Blend", "spine/bigwin/bigWinL2Blend.json"),
                    new SpineAsset("bigWinL3Blend", "spine/bigwin/bigWinL3Blend.json"),
                    new SpineAsset("bigWinL4Blend", "spine/bigwin/bigWinL4Blend.json"),
                    new SpineAsset("bigWinL5Blend", "spine/bigwin/bigWinL5Blend.json"),
                    new SpineAsset("bigWinUnderL3", "spine/bigwin/bigWinUnderL3NORMAL.json"),
                    new SpineAsset("bigWinUnderL4", "spine/bigwin/bigWinUnderL4NORMAL.json"),
                    new SpineAsset("bigWinUnderL5", "spine/bigwin/bigWinUnderL5NORMAL.json"),
                    new SpineAsset("multiplier", "spine/multiplier.json"),
                    new SpineAsset("symbolIdle", "spine/idle/symbolIdle.json"),
                    new SpineAsset("mainIdle", "spine/idle/mainBGIdle.json"),
                    new SpineAsset("mainIdleDust", "spine/idle/mainBgDust.json"),
                    new SpineAsset("mainIdleWeed", "spine/idle/tumbleWeed.json"),
                ]
            },
        ]
    };
}